import React, { useState } from 'react';
import {
    Box, Paper, Typography, TableContainer,
    Table, TableBody, TableRow, TableCell, Link,
    Collapse, IconButton
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { logEvent } from '../analytics';

export interface LinkItem {
    label: string;
    url: string;
    displayText?: string;
}

interface LinksTableProps {
    title: string;
    links: LinkItem[];
    defaultOpen?: boolean;
}

const LinksTable: React.FC<LinksTableProps> = ({ title, links, defaultOpen = true }) => {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2, mb: 4 }}>
            <Table aria-label={`${title} links table`}>
                <TableBody>
                    <TableRow onClick={() => {
                        setOpen(!open);
                        logEvent('toggle_links_section', { section_title: title, open: !open });
                    }} sx={{ cursor: 'pointer' }}>
                        <TableCell colSpan={2} sx={{ bgcolor: 'grey.200' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 'bold' }}>
                                    {title}
                                </Typography>
                                <IconButton size="small">
                                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </IconButton>
                            </Box>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={2} sx={{ p: 0, border: 0 }}>
                            <Collapse in={open} timeout="auto" unmountOnExit>
                                <Table>
                                    <TableBody>
                                        {links.map((link) => (
                                            <TableRow key={link.label} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell component="th" scope="row" sx={{ fontWeight: 'medium', width: { xs: '40%', md: '30%' } }}>
                                                    {link.label}
                                                </TableCell>
                                                <TableCell>
                                                    <Link
                                                        href={link.url} target="_blank" rel="noopener noreferrer" sx={{ wordBreak: 'break-all' }}
                                                        onClick={() => logEvent('click_external_link', { link_label: link.label, link_url: link.url })}
                                                    >
                                                        {link.displayText || link.url}
                                                    </Link>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Collapse>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default LinksTable;